import React, { useState } from "react";
import { AnimatePresence } from "framer-motion";
import s from "./SelectableProductCard.module.css";
import { DeleteIcon, EditPenIcon } from "../../../../../utils/Icons";
import { useNavigate } from "react-router-dom";
import DeleteConfirmPopup from "../../../../GlobalComponents/DeleteConfirmPopup/DeleteConfirmPopup";

export default function SelectableProductCard({
  product,
  onDelete,
  children,
  disabled = false,
}) {
  const navigate = useNavigate();
  const [openConfirmPopup, setopenConfirmPopup] = useState(false);

  const handleOpenConfirmPopup = (e) => {
    e.stopPropagation();
    setopenConfirmPopup(true);
  };
  const handleCloseConfirmPopup = () => setopenConfirmPopup(false);
  const handleConfirmSubmit = () => {
    onDelete?.(product?._id);
    handleCloseConfirmPopup();
  };

  return (
    <>
      <div
        className={`${s.wrap} ${disabled ? s.disabled : ""}`}
        role="button"
        tabIndex={disabled ? -1 : 0}
      >
        {!disabled && (
          <div className={s.topBtns} aria-hidden>
            <button
              className={s.deleteBtn}
              title="Edit Product"
              onClick={(e) => {
                e.stopPropagation();
                navigate(`/listings/${product?._id}/edit`, { state: { listing: product } });
              }}
            >
              <EditPenIcon height={18} fill="var(--secondary-color)" />
            </button>

            <button
              className={s.deleteBtn}
              title="Delete Product"
              onClick={handleOpenConfirmPopup}
            >
              <DeleteIcon height={18} fill="var(--secondary-color)" />
            </button>
          </div>
        )}
        {children}
      </div>

      <AnimatePresence>
        {openConfirmPopup && (
          <DeleteConfirmPopup
            handleClose={handleCloseConfirmPopup}
            handleSubmit={handleConfirmSubmit}
          />
        )}
      </AnimatePresence>
    </>
  );
}
